import React, { useEffect } from "react"

import { useNavigate, useSearchParams } from "react-router-dom"
import axios from "axios"
import { useAuth } from "../contexts/AuthContext"

import { toast } from "react-toastify"

function LogoutPage() {
  const navigate = useNavigate()
  const { user, login, logout } = useAuth()

  const token = localStorage.getItem("token")

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Authorization: token,
    },
  })

  const disconnect = async () => {
    api
      .post("user/logout")
      .then((response) => {
        logout()
        localStorage.removeItem("isAdmin")
        localStorage.removeItem("token")

        toast.warn("Sessão encerrada", {
          theme: "colored",
        })

        navigate("/login")
      })
      .catch((error) => {
        console.log("Error logging out:")
        const errorMsg = error.response
          ? (error.response.data.message || error.response.data.error || "Erro na autenticação")
          : "Erro interno no servidor, contate um administrador"

        toast.error(errorMsg, {
          theme: "colored",
          autoClose: 10000,
        })

        navigate("/login")
      })
  }

  useEffect(() => {
    disconnect()
  }, [])

  return null
}

export default LogoutPage
